import { apiClient } from './client';

/**
 * Session PDF reports (PDF-REPORTS). Request a render (async worker job), then
 * poll status until the PDF is on S3 and a presigned download URL comes back.
 */

export interface ReportStatus {
  status: 'ready' | 'processing' | 'failed' | 'none';
  url?: string | null;
  filename?: string | null;
  expires_in_seconds?: number | null;
}

/** Enqueue a PDF render of the session's report (idempotent while in flight). */
export async function requestSessionReport(
  tenantId: string,
  sessionId: string,
): Promise<void> {
  await apiClient.post(
    `/api/v1/tenants/${tenantId}/sessions/${sessionId}/report`,
  );
}

/** Report status + (when ready) a short-lived presigned download URL. */
export async function getSessionReport(
  tenantId: string,
  sessionId: string,
): Promise<ReportStatus> {
  const { data } = await apiClient.get<ReportStatus>(
    `/api/v1/tenants/${tenantId}/sessions/${sessionId}/report`,
  );
  return data;
}

// --- Participant self-service (their OWN session) --------------------------

/** Enqueue a PDF render of the participant's own session report. */
export async function requestMySessionReport(sessionId: string): Promise<void> {
  await apiClient.post(
    `/api/v1/sessions/me/${encodeURIComponent(sessionId)}/report`,
  );
}

/** Report status + (when ready) a download URL for the participant's own
 *  session. */
export async function getMySessionReport(
  sessionId: string,
): Promise<ReportStatus> {
  const { data } = await apiClient.get<ReportStatus>(
    `/api/v1/sessions/me/${encodeURIComponent(sessionId)}/report`,
  );
  return data;
}
